export const ui = {
    contentSections: document.querySelectorAll('.content-section') as NodeListOf<HTMLElement>,
    navLinks: document.querySelectorAll('.subMenu-link') as NodeListOf<HTMLAnchorElement>,
    public: {
        menu: document.querySelector('.menu') as HTMLElement,
        navMenu: document.querySelector('.nav-menu') as HTMLElement,
    },
    ambassador: {
        menu: document.querySelector('.ambassador .header__toggle') as HTMLElement,
        navMenu: document.querySelector('.ambassador .menu') as HTMLElement,
    }
}
